import type { ReactNode, Ref } from 'react'
import cx from 'classnames'
import styles from './SplitView.module.css'

interface SplitViewProps {
  children?: ReactNode
  flexChild?: boolean
}

/**
 * Lays a side pane out next to the main content.
 */
export function SplitView({ children, flexChild }: SplitViewProps) {
  return (
    <div className={cx(styles.root, flexChild && styles.flexChild)}>
      {children}
    </div>
  )
}

interface SplitViewSideProps {
  children?: ReactNode
  collapsed?: boolean
  highlightBorder?: boolean
  narrow?: boolean
  ref?: Ref<HTMLDivElement>
}

/**
 * The side pane of a {@link SplitView}, which can collapse.
 */
export function SplitViewSide({
  children,
  collapsed,
  highlightBorder,
  narrow,
  ref,
}: SplitViewSideProps) {
  return (
    <div
      ref={ref}
      className={cx(
        styles.side,
        collapsed && styles.collapsed,
        highlightBorder && styles.highlightBorder,
        narrow && styles.narrow,
      )}
    >
      {children}
    </div>
  )
}

interface SplitViewMainProps {
  children?: ReactNode
  ref?: Ref<HTMLDivElement>
}

/**
 * The main content of a {@link SplitView}.
 */
export function SplitViewMain({ children, ref }: SplitViewMainProps) {
  return (
    <div ref={ref} className={styles.main}>
      {children}
    </div>
  )
}
